// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInstrumentCategoryTypeDto
 */
export interface IInstrumentCategoryTypeDto {
    /**
     * 
     * @type {number}
     * @memberof IInstrumentCategoryTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInstrumentCategoryTypeDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof IInstrumentCategoryTypeDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IInstrumentCategoryTypeDto interface.
 */
export function instanceOfIInstrumentCategoryTypeDto(value: object): value is IInstrumentCategoryTypeDto {
    return true;
}

export function IInstrumentCategoryTypeDtoFromJSON(json: any): IInstrumentCategoryTypeDto {
    return IInstrumentCategoryTypeDtoFromJSONTyped(json, false);
}

export function IInstrumentCategoryTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInstrumentCategoryTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IInstrumentCategoryTypeDtoToJSON(json: any): IInstrumentCategoryTypeDto {
    return IInstrumentCategoryTypeDtoToJSONTyped(json, false);
}

export function IInstrumentCategoryTypeDtoToJSONTyped(value?: IInstrumentCategoryTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'description': value['description'],
    };
}

